import { render, staticRenderFns } from "./ListagemAlunos.vue?vue&type=template&id=38867223&scoped=true"
import script from "./ListagemAlunos.vue?vue&type=script&lang=js"
export * from "./ListagemAlunos.vue?vue&type=script&lang=js"
import style0 from "./ListagemAlunos.vue?vue&type=style&index=0&id=38867223&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38867223",
  null
  
)

export default component.exports